import { useTranslation } from 'react-i18next'

const MumToDisabledChildEnd = (props) => {
  const { t } = useTranslation()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="mumtodisabledchild-end-title"
      {...props}
    >
      <title id="mumtodisabledchild-end-title">{t('antagonists:mumtodisabledchild:components:end')}</title>
      <path
        d="m1536.14 517.72 34.24 2.64s-4.4 19.76-6.83 28.89c-2.42 9.12-11.48 34.98-11.48 40.39s1.61 7.09 3.26 15.08-2.55 16.06-3.86 20.74c-1.3 4.68.27 5.56-.13 11.21-.4 5.65-2.08 8.33-3.12 10.17-.52.92-4.75-.8-4.75-.8s-1.19-4.69-1.22-7.81c-.03-3.12 1.98-12.21-.34-12.66s-2.68 5.82-2.6 9.56 2.45 9.49 3.39 10.87c.93 1.39 11.15 1.98 14.08 5.94 1.66 2.24-.6 6.18-.6 6.18s-21.41-6.25-23.4-8.05c-1.09-.99-6.4-19.13-6.5-22.06-.19-5.67 6.38-29.54 8.47-40.31s1.4-69.97 1.4-69.97h-.01Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="m1624.78 938.55-.82 13.08 6.95 2.04 3.9-6.83s.29-4.13-1.48-5.56c-2.15-1.72-8.56-2.73-8.56-2.73h.01ZM1544.02 959.2l13.9 11.04-6.34 11.24-18.33-2.42s-1.7-10.26-.27-13.12c1.43-2.87 11.04-6.75 11.04-6.75ZM1572.85 945.92l10.83-2.25-1.43-9.2-10.63 1.02s0 2.25.2 4.7 1.02 5.72 1.02 5.72h.01ZM1551.38 960.42l1.84-5.11-7.77-4.91-.82 7.77 6.75 2.25z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="m1621.29 860.26-38.84 2.45s8.18 33.32 9.61 39.66c1.44 6.33 1.03 14.51-.2 18.6-1.23 4.09-12.88 18.81-22.08 23.1-9.2 4.3-19.22 8.79-22.08 10.43-2.86 1.63-8.18 8.58-8.38 13.08-.21 4.5 1.02 5.72 5.72 7.36 4.7 1.63 9-.62 16.97-3.48 7.97-2.86 65.28-12.48 68.89-25.55 2.66-9.61-3.89-16.97-5.93-30.05-1.19-7.61-3.68-55.61-3.68-55.61Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="m1616.59 951.85-55.81 22.69s.41-2.87-1.84-10.43-13.7-11.24-13.7-11.24l.2-2.45 12.67-7.16s9.4 6.54 12.88 8.99c3.48 2.45 6.55 6.95 9 7.97s10.22-4.5 10.63-8.18-2.45-6.54-7.77-11.86c-5.31-5.31-11.24-4.7-11.24-4.7l10.22-9.4s8.26.97 16.97 7.97c6.95 5.59 17.79 17.79 17.79 17.79Z"
        style={{
          fill: '#4f4e47',
        }}
      />
      <path
        d="M1634.38 943.25c.81.69.43 17.26.43 17.26s-71.57 22.49-83.22 23.92c-11.65 1.43-18.4-5.41-18.4-5.41l-.61-9.4s6.54 7.36 11.45 7.36c4.9 0 11.24-2.86 16.76-5.52s26.37-13.7 34.34-18.81c7.97-5.11 20.04-3.88 29.44-4.7s9-5.39 9.81-4.7Z"
        style={{
          fill: '#4f4e47',
        }}
      />
      <path
        d="m1686.51 871.68-26.37-1.43s.82 11.66.82 15.54-2.45 12.47-2.45 17.58 1.23 8.17 1.84 12.67-1.02 6.33-.41 10.63 1.84 4.71 5.72 8.59c3.89 3.89 5.52 14.11 6.34 17.79.82 3.68 1.23 6.95 4.91 8.79 3.68 1.84 12.87.21 20.03-2.45 7.15-2.65 12.26-7.15 10.83-10.83s-11.45-19.83-16.15-24.12c-4.7-4.3-5.31-13.29-4.29-16.97s.41-12.47-1.23-18.19c-1.63-5.72.41-17.58.41-17.58v-.02Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="m1696.32 915.86 5.52 11.24-.41 5.72 6.37 1.96 4.05 8.47-.82 2.04s-1.02 1.84-.2 3.68-1.06 12.12-1.68 13.56-6.29 3.96-12.63 6.21-11.16 3-16.48 3c-5.31 0-8.67-3.95-10.51-7.63-1.83-3.68-11.2-24.15-12.67-26.78s-.61-14.31-.61-14.31 8.79-9.41 18.81-11.86c10.02-2.46 21.26 4.7 21.26 4.7Z"
        style={{
          fill: '#4f4e47',
        }}
      />
      <path
        d="M1706.13 945.3s-13.5-.82-22.49 0-11.65 4.7-11.65 4.7.21 2.87.41 5.32c.21 2.45-.2 4.7 4.5 6.54 4.7 1.84 9.2.2 15.33-.82 6.13-1.03 14.51-6.55 16.15-10.43 1.63-3.89-2.25-5.32-2.25-5.32ZM1699.03 932.02s-.77-1.82-2.11-3.54-8.33-7.94-18.89-6.23c-14.1 2.28-13.84 7.95-13.9 10.83-.06 2.98 1.02 8.18 1.84 7.36s2.86-5.93 12.06-6.54c9.2-.62 21-1.88 21-1.88Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="m1719.19 530.57-96.31-16.72s-3.35 30.1-2.01 51.5c1.34 21.4 19.4 149.15 19.4 169.21s10.03 38.13 9.36 64.21c-.67 26.08 3.52 87.26 3.52 87.26s17.17 6.7 24.72 5.25c5.26-1.01 17.91-5.56 17.91-5.56s3.34-59.53 4.68-87.62c1.34-28.09-3.34-50.83-5.35-63.54-2.01-12.7 4.01-40.79 11.37-82.93s12.71-121.06 12.71-121.06Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        d="M1554.67 508.5s81.6 17.39 79.59 16.72c-2.01-.67-12.71 188.74-13.38 207.47-.67 18.72 2.83 40.9 4.84 66.98 2 26.08 1.61 100.07 1.61 100.07s-22.54 7.75-27.79 8.49c-6.6.93-15.45-5.13-15.45-5.13s-18.06-122.39-18.06-140.45c0-18.05-11.37-58.18-18.06-110.35-6.69-52.17 6.69-143.8 6.69-143.8h.01Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        d="M1636.84 159.2c-5.31.09-10.99-1.47-18.4 3.17-10.69 6.69-19.35 21.66-23.63 36.04-4.09 13.75-3.9 29-12.25 48.38-7.9 18.35-.64 25.83 8.79 31.71 10.15 6.33 51.01 15.77 65.57 9.78 15.68-6.45 26.65-16.47 28.2-37.35 1.58-21.29-7.27-76.63-21.68-85.75-14.4-9.13-22.68-6.03-26.58-5.97h-.02Z"
        style={{
          fill: '#814d34',
        }}
      />
      <path
        d="m1658.22 232.53-47.88 8.94s.41 13.51.05 22.81c-.37 9.3 1.04 20.61-3.7 26.63s-23.1 14.69-23.1 14.69-6.45 45.52-7.18 45.33 128.62-12.41 128.62-12.41l3.9-40.66-18.92-7.66s-16.66-5.28-30.07-10.16c-8.28-3.01-6.83-14.74-6.91-19.91-.09-5.17 5.19-27.61 5.19-27.61Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1637.1 179.74c-4.02-.16-9.41.83-15.57 2.13-6.16 1.29-13.48 11.83-15.02 19.02-1.54 7.19-6.08 34.26-6.49 38.99s3.04 11.44 9.46 17.67c6.42 6.23 22.1 9.06 35.03 7.8 12.93-1.26 20.32-18.56 20.32-18.56s-4.96-36.15-7.14-48.97c-2.18-12.82-10.17-17.65-20.59-18.08Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1606.58 212.98c-.41.51-2.78 19.35-2.78 19.35s-3.43 1.54-6.2-.35c-2.77-1.89-.16-6.61 1.04-12s-1.34-12.02 1.83-12.66c3.17-.64 6.1 5.66 6.1 5.66h.01Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1638.46 248.94c1.14-2.64-1.15-6.01-3.6-7.32s-4.03.02-4.94-.06-1.18-1.2-3.68-1.97c-2.5-.76-7.68 2.03-7.85 4.03-.18 2 5.63 8.41 9.94 9.33 4.31.92 9.52-2.63 10.12-4.01h.01Z"
        style={{
          fill: '#ed7a30',
        }}
      />
      <path
        d="M1654.74 206.38c5.36 1.1 8.74 6.44 8.74 6.44l-1.37 2.14s-4-3.24-6.75-4.36-12.59-1.26-12.59-1.26v-4.5s6.61.45 11.97 1.54Z"
        style={{
          fill: '#814d34',
        }}
      />
      <path
        d="M1713.81 499.85c3.56-3.12 6.75-6.03 8.73-8.13 2.98-3.18 10.31-12.13 17.32-20.82l-.96-.61s10.39-15.77 17.65-27.51c-2.12-4.07-3.96-8.17-5.69-11.75-4.08-8.44-19.73-29.93-29.77-43.15-5.62 27.28-11.82 56.67-13.91 67.52-3.08 16 2.55 30.75 6.63 44.46Z"
        style={{
          fill: 'none',
        }}
      />
      <path
        d="M1716.3 536.04c-1.6 2.23-4.91 10.3-7.03 14.51 4.7 4.36 7.57 7.6 8.57 7.2 1.67-.67 2.01-11.95 1.29-24.4-1.52 1.34-2.56 2.31-2.83 2.69Z"
        style={{
          fill: '#8cabbc',
        }}
      />
      <path
        d="m1657.4 536.73-9.54 11.82s3.52 3.73 6.84 2.07c3.32-1.66 8.92-7.67 8.92-7.67l9.31-3.87s4.56 6.09 13.69 11.41c9.13 5.32 19.78 2.66 20.92 2.66.31 0 .94-1.04 1.72-2.6 2.12-4.21 5.43-12.28 7.03-14.51.28-.38 1.32-1.35 2.83-2.69 5.38-4.75 17.08-14.38 24.56-20.88 4.85-4.21 15.23-14.36 24.5-23.57l-28.33-17.99c-7 8.69-14.34 17.64-17.32 20.82-1.98 2.1-5.17 5.01-8.73 8.13-8.01 7.04-17.88 15.15-19.89 17.59-2.91 3.53-8.71 1.45-13.69 3.94-2.59 1.3-8.67 5.41-13.91 9.05-4.81 3.34-8.9 6.29-8.9 6.29h-.01Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="m1532.12 526.05 17.26 1.95c-1.85 13.72-7.07 35.27-5.78 36.49 2.51 2.37 28.27-3.65 52.64-9.61 24.61-6.02 53.88-25.21 69.94-24.45.05 0 .09.01.14.01 5.23-3.64 11.31-7.75 13.91-9.05 4.98-2.49 10.79-.41 13.69-3.94 2.01-2.45 11.88-10.56 19.89-17.59-4.08-13.71-9.71-28.46-6.63-44.46 2.09-10.85 8.29-40.24 13.91-67.52 10.04 13.22 25.7 34.71 29.77 43.15 1.73 3.58 3.56 7.67 5.69 11.75-7.26 11.75-17.65 27.51-17.65 27.51l.96.61 28.33 17.99 7.68 4.88s21.46-31.91 26.4-42.18c.4-.83.66-1.67.86-2.52.3-.67.4-1.68.32-2.99-.02-.88-.12-1.76-.32-2.64-2.22-12.97-14.29-41.39-18.36-48.91-4.95-9.13-39.07-76.58-46.79-86.76-4.02-5.29-10.08-7.94-14.86-9.27-6.38-2.87-13.28-4.6-19.36-5.89-8.11-1.71-20.09-4.85-20.09-4.85s-12.12 37-49.02 41.18c-21.62 2.45-44.28-27.2-44.28-27.2s-23.24 8.68-29.93 14.76c-2.47 1.88-4.79 4.2-6.52 7.1-6.43 10.79-9.18 45.25-7.53 66.87s.88 48.37-1.38 63.8-12.9 71.78-12.9 71.78h.01Z"
        style={{
          fill: '#8cabbc',
        }}
      />
      <path
        d="m1628.84 202.95-.27 4.64s-10.37-.3-13.52.2-5.26 3.53-5.26 3.53l-1.3-1.24s1.47-3.16 3.9-4.94c2.63-1.93 16.45-2.18 16.45-2.18Z"
        style={{
          fill: '#814d34',
        }}
      />
      <path
        d="M1649.19 220.34c-.15-.09-.11-2.4-.11-2.4l5.52 2.98-.82 1.61-4.59-2.19Z"
        style={{
          fill: '#1a4431',
        }}
      />
      <path
        style={{
          fill: '#1a4431',
        }}
        d="m1648.75 217.13 5.53-1.62.5 1.77-6.02 1.98-.01-2.13z"
      />
      <path
        d="M1650.41 216.54c-1.07-1.72-3.22-1.76-4.36-.94-1.62 1.16-1.92 2.62-.7 4.32 1.03 1.44 2.35 2.09 4.03 1.13 1.67-.96 2.06-2.84 1.02-4.51ZM1616.68 216.59c.16-.07.43-2.36.43-2.36l-5.87 2.22.59 1.71 4.85-1.56Z"
        style={{
          fill: '#1a4431',
        }}
      />
      <path
        style={{
          fill: '#1a4431',
        }}
        d="m1617.19 213.44-5.07-2.25-.71 1.62 5.49 2.67.29-2.04z"
      />
      <path
        d="M1616.55 212.95c1.3-1.56 3.42-1.31 4.45-.35 1.45 1.37 1.66 2.61.23 4.13-1.21 1.28-2.73 1.99-4.26.82-1.54-1.17-1.68-3.08-.42-4.6Z"
        style={{
          fill: '#1a4431',
        }}
      />
      <path
        d="M1627.92 304.81c3.33-2.53 9.16-2.74 12.09.82 3.31 4.01 2.37 8.89-1.04 11.84-4.08 3.54-9.67 1.88-12.21-.95-2.16-2.4-3.07-8.49 1.16-11.71Zm3.35.87c-1.37 1.04-1.08 3.01-.38 3.79.82.92 2.63 1.45 3.96.31 1.11-.95 1.41-2.53.34-3.83-.95-1.16-2.84-1.09-3.92-.27Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        d="M1631.9 303.53c-19.27 0-26.7-13.87-26.77-14.02-.13-.25-.03-.57.22-.7s.56-.04.7.22c.08.14 7.83 14.43 27.91 13.4 22.79-1.16 27.38-22.22 27.42-22.43.05-.29.3-.46.61-.41.28.05.46.33.4.61-.04.22-4.78 22.07-28.38 23.27-.72.03-1.42.05-2.11.05Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
    </svg>
  )
}

export default MumToDisabledChildEnd
